import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Announcing: Big update to my best selling book and course, React + D3v4",
  "description": "",
  "published": "2018-07-26T00:00:00.000Z",
  "redirect_from": ["/blog/announcing-big-update-best-selling-book-course-react-d3v4/swizec/8527"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So the director of dataviz at VISA emailed me the other day.`}</p>
    <p>{`He said “Yo, we love your book on React data visualization. The team is learning fast, getting a lot done. Honestly, it’s helped a lot.”`}</p>
    <p>{`Wow! Fortune 200 companies use my stuff!!`}</p>
    <p>{`“But dude, some examples are out of date” 😵`}</p>
    <p>{`He’s not wrong ... my in-person React dataviz workshop went through many changes over the past year. Updates to content, new techniques researched ... lots of stuff.`}</p>
    <p>{`SO I'VE DECIDED…`}</p>
    <p>{`🎉 I’m updating React + D3v4 🎉`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/07/DiraLuPWAAERMng-768x1024.jpg",
        "alt": null
      }}></img></p>
    {
      /*[if mso]>
       <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://gumroad.com/l/pMtnZ" style="height:40px;v-text-anchor:middle;width:200px;" arcsize="10%" strokecolor="#1e3650" fillcolor="#ffa824">
         <w:anchorlock/>
         <center style="color:#ffffff;font-family:sans-serif;font-size:13px;font-weight:bold;">Preorder now!</center>
       </v:roundrect>
      <![endif]*/
    }
    <p><a parentName="p" {...{
        "href": "https://gumroad.com/l/pMtnZ"
      }}>{`Preorder now!`}</a></p>
    <p>{`It’s going to become React + D3 2018, or maybe it's time for a new title, I haven't decided.`}</p>
    <p>{`Here’s the plan 👇`}</p>
    <ul>
      <li parentName="ul">{`Finish in time for the Reactathon conference on September 8th.`}</li>
      <li parentName="ul">{`Lead a new and improved in-person workshop.`}</li>
      <li parentName="ul">{`Moderate discussion table.`}</li>
      <li parentName="ul">{`Launch book.`}</li>
    </ul>
    <p>{`Here’s what you get 👇`}</p>
    <ul>
      <li parentName="ul">{`⚛️ updated content for how react works in 2018 and 2019. That means React 16+, React Suspense, etc.`}</li>
      <li parentName="ul">{`📈 updated code for D3v5`}</li>
      <li parentName="ul">{`🚟 exploration of React Suspense implications`}</li>
      <li parentName="ul">{`🆕 a chapter on ready-made dataviz components you can use`}</li>
      <li parentName="ul">{`🆕 new chapter on dataviz in React Native`}</li>
      <li parentName="ul">{`🆕 new chapter on dataviz in WebVR`}</li>
      <li parentName="ul">{`📦 move examples from Codepen to Codesandbox for a better experience`}</li>
      <li parentName="ul">{`🏃 add more exercises and sample walkthroughs`}</li>
      <li parentName="ul">{`🎥 all new 2 to 3-hour video in full 4K`}</li>
    </ul>
    <h3 {...{
      "id": "and-only-if-you-preorder-"
    }}>{`AND ONLY IF YOU PREORDER 👇`}</h3>
    <p>{`3 live online workshops on Aug 12, 19, 26. We'll build some dataviz and I’ll answer any questions you can come up with.`}</p>
    <p>{`Workshops will be recorded and you will keep access to them forever. Even if you can’t join live. But only if you buy now.`}</p>
    <p>{`3 years of thought and research will have gone into this book. Countless hours spent talking through problems with in-person workshop attendees, coaching clients, and helping big Fortune50 companies.`}</p>
    <p>{`You don’t wanna miss this.`}</p>
    {
      /*[if mso]>
       <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://gumroad.com/l/pMtnZ" style="height:40px;v-text-anchor:middle;width:200px;" arcsize="10%" strokecolor="#1e3650" fillcolor="#ffa824">
         <w:anchorlock/>
         <center style="color:#ffffff;font-family:sans-serif;font-size:13px;font-weight:bold;">Preorder now!</center>
       </v:roundrect>
      <![endif]*/
    }
    <p><a parentName="p" {...{
        "href": "https://gumroad.com/l/pMtnZ"
      }}>{`Preorder now!`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      